import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_BILLING_CODE_RESET = 'POST_BILLING_CODE_RESET';
export const POST_BILLING_CODE_LOADING = 'POST_BILLING_CODE_LOADING';
export const POST_BILLING_CODE_SUCCESS = 'POST_BILLING_CODE_SUCCESS';
export const POST_BILLING_CODE_REJECT = 'POST_BILLING_CODE_REJECT';

//* ACTIONS ------------------------------------------------
export const postBillingCodeReset = () => ({ type: POST_BILLING_CODE_RESET });
export const postBillingCodeLoading = () => ({ type: POST_BILLING_CODE_LOADING });
export const postBillingCodeSuccess = (payload) => ({ type: POST_BILLING_CODE_SUCCESS, payload });
export const postBillingCodeReject = (payload) => ({ type: POST_BILLING_CODE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postBillingCodeRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/BillingCode/web/AddBillingCode`, options);
};
